// extracted by mini-css-extract-plugin
export default {"wrapper":"TV-z","availablePromoMessagesLabel":"UV-z","promoMessageList":"VV-z","promoMessage":"WV-z","appliedPromoMessage":"XV-z","promoMessageAmount":"YV-z"};